const ID_TOKEN_KEY = "id_token" as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
    return localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
    localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
    localStorage.removeItem(ID_TOKEN_KEY);
    localStorage.removeItem("profile_user");
    localStorage.removeItem("menus");
    localStorage.removeItem("permissions");
};

/**
 * @description save user into localStorage
 * @param token: string
 */
export function saveUser(data) {
    localStorage.setItem("profile_user", JSON.stringify(data));
}

/**
 * @description get token form localStorage
 */
export function getProfileUser() {
    const user = localStorage.getItem("profile_user");
    return JSON.parse(user || "{}");
}

/**
 * @description menus form localStorage
 */
export function saveMenus(data) {
    localStorage.setItem("menus", JSON.stringify(data));
}

export function getMenus() {
    const menus = localStorage.getItem("menus");
    return JSON.parse(menus || "{}");
}

/**
 * @description menus form localStorage
 */
export function savePermissions(data) {
    localStorage.setItem("permissions", JSON.stringify(data));
}

export function getPermissions() {
    const permissions = localStorage.getItem("permissions");
    return JSON.parse(permissions || "{}");
}

export default {
    getToken,
    saveToken,
    destroyToken,
    saveUser,
    savePermissions,
    getPermissions,
    getProfileUser,
    saveMenus,
    getMenus,
};
